import React from 'react'
import PropTypes from 'prop-types'
import { Link, useLocation } from 'react-router-dom'
import { useTheme } from 'styled-components'
import { Tonality } from '@dsny/dsny-component-library'
import PlaceholderLogo from 'images/icons/placeholder_circle.png'
import {
  ArtistSearchCardContainer,
  ImageContainer,
  ArtistSearchCardImage,
  TextContainer
} from './ArtistSearchCard.styles'

export default function ArtistSearchCard({ artist }) {
  const theme = useTheme()
  const location = useLocation()
  const searchBackTo = `${location.pathname}${location.search}${location.hash}`

  return (
    <Link
      state={{ searchBackTo }}
      to={`/search/releases/artist?q=${encodeURIComponent(artist.artist)}`}
      style={{ textDecoration: 'none' }}
    >
      <ArtistSearchCardContainer>
        <ImageContainer>
          <ArtistSearchCardImage
            src={artist?.image || PlaceholderLogo}
            alt="artist image"
          />
        </ImageContainer>

        <TextContainer>
          <Tonality.UIText
            textStyle="bodyBold"
            color={theme.colors.neutralW100}
          >
            {artist?.artist}
          </Tonality.UIText>
          <Tonality.UIText textStyle="body" color={theme.colors.neutralW70}>
            {artist?.releases} releases
          </Tonality.UIText>
        </TextContainer>
      </ArtistSearchCardContainer>
    </Link>
  )
}

ArtistSearchCard.propTypes = {
  artist: PropTypes.shape({
    artist: PropTypes.string,
    releases: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image: PropTypes.string
  }).isRequired
}
